import { cssInterop } from 'nativewind';
import { type ComponentType } from 'react';
import Animated from 'react-native-reanimated';
import { Circle, type CircleProps } from 'react-native-svg';

// A react-native-svg `Circle` that (1) accepts a NativeWind `className` so
// `stroke`/`fill` can use design-system tokens (e.g. `stroke-primary-500`,
// adapting to dark mode) instead of hardcoded hex, and (2) is animatable via
// reanimated `animatedProps` (e.g. an animated `strokeDashoffset` for progress
// rings). The cssInterop bridge mirrors icons.ts: NativeWind resolves the
// className into `style.stroke` / `style.fill`, forwarded to the SVG props.
// CircleProps doesn't type `style`, so we widen it for the (fussy) cssInterop
// overload, then cast back to a className-aware component type.
const ThemedCircle = cssInterop(Circle as ComponentType<CircleProps & { style?: unknown }>, {
  className: { target: 'style', nativeStyleToProp: { stroke: true, fill: true } },
}) as unknown as ComponentType<CircleProps & { className?: string }>;

export const AnimatedCircle = Animated.createAnimatedComponent(ThemedCircle);
